export default __webpack_public_path__ + "static/media/imgComp5.a5d47657.webp";